<template>
  <div :style="container_style" :class="container_class">
    <div v-if="show_btn" :style="slot_style" :class="slot_class" @click.prevent="show()">
      <slot>
        <li>
          <a href="#">Category Title</a>
        </li>
      </slot>
    </div>

    <vue-modal
      v-if="isModalVisible"
      modal_title="Get Quotes"
      container_style="min-width:60%;height:500px;overflow:hidden;text-align:left;margin-top:100px;position:relative;z-index:999;"
      body_container_style="min-width:60%;height:500px;overflow:hidden;padding:0;"
      @close="hide"
    >
      <template v-slot:header>
        <div></div>
      </template>
      <template v-slot:body>
        <create-task
          @close="hide"
          v-if="signin"
          :first_step="firstStep"
          :steps="6"
          :category_id="category_id"
          :suburb_id="suburb_id"
          :redirect_url="redirect_url"
          @getTask="getTask"
        ></create-task>
        <create-task
          v-else
          :first_step="firstStep"
          :steps="7"
          :category_id="category_id"
          :suburb_id="suburb_id"
          :redirect_url="redirect_url"
          @getTask="getTask"
        ></create-task>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </vue-modal>
  </div>
</template>

<script>
import VueModal from "./../../VueModal";
import CreateTask from "./CreateTask";
export default {
  name: "get-quotes",
  components: {
    VueModal,
    CreateTask
  },

  props: {
    category_id: {
      type: [String, Number]
    },
    suburb_id: {
      type: [String, Number]
    },
    signin: {
      type: Boolean,
      default: false
    },
    show_btn: {
      type: Boolean,
      default: true
    },
    show_modal: {
      type: Boolean,
      default: false
    },
    slot_class: {
      type: String,
      default: ""
    },
    slot_style: {
      type: String,
      default: ""
    },
    container_class: {
      type: String,
      default: ""
    },
    container_style: {
      type: String,
      default: ""
    },
    redirect_url: {
      type: String,
      default: "/dashboard/task"
    }
  },

  methods: {
    getTask(task) {
      this.task = task;
      this.$emit("getTask", this.task);
      this.hide();
    },
    show() {
      this.isModalVisible = true;
    },
    hide() {
      this.isModalVisible = false;
      this.$root.$data.get_quotes_modal_show = false;
    },
    getStep(step) {
      this.step = step;
    }
  },
  data() {
    return {
      isModalVisible: this.show_modal,
      firstStep: 1,
      task: null
    };
  },
  created() {
    if (this.category_id != null && this.category_id != undefined) {
      this.firstStep = 2;
    }
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
